'use strict';

import {EwSiteApp} from "./ewsiteapp";

EwSiteApp.controller('PdfController', ['$scope', 'pdfService', '$timeout', function ($scope, pdfService, $timeout) {

    $scope.downloadPDF = function (fileTitle) {
        const contentSelector = '.ew-content';
        pdfService.generatePDF(contentSelector, fileTitle);
    };

    $scope.defaultPrint = function () {
        const tabContents = document.querySelectorAll('md-tab-content.md-right:not(.md-active), md-tab-content.md-right:not(.md-active) *');

        const originalStyles = [];
        tabContents.forEach((element, index) => {
            const computedStyle = window.getComputedStyle(element);
            originalStyles[index] = {
                transform: computedStyle.transform,
                visibility: computedStyle.visibility,
                position: computedStyle.position,
                transition: computedStyle.transition
            };

            element.style.transform = 'none';
            element.style.visibility = 'visible';
            element.style.position = 'relative';
            element.style.transition = 'none';
        });

        const handleAfterPrint = () => {
            tabContents.forEach((element, index) => {
                element.style.transform = originalStyles[index].transform || '';
                element.style.visibility = originalStyles[index].visibility || '';
                element.style.position = originalStyles[index].position || '';
                element.style.transition = originalStyles[index].transition || '';
            });

            window.removeEventListener('afterprint', handleAfterPrint);
            window.location.reload();
        };

        window.addEventListener('afterprint', handleAfterPrint);

        $timeout(() => {
            window.print();
        }, 0);
    };
}]);
